import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginSteps } from 'suits-me-npm/constants';
import {
    getAuthError,
    getAuthIsPosting,
    getAuthLoginStep,
    getPostTokenSuccess,
} from 'suits-me-npm/selectors';
import { updateLanguageCode } from 'suits-me-npm/actions';
import useLocalStorage from './useLocalStorage';

export default () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const loginStep = useSelector(getAuthLoginStep);
    const isPosting = useSelector(getAuthIsPosting);
    const error = useSelector(getAuthError);
    const token = useSelector(getPostTokenSuccess);

    const [languageCode] = useLocalStorage('languageCode', {});

    useEffect(() => {
        if (loginStep === loginSteps.Complete) {
            localStorage.setItem('token', token);

            dispatch(updateLanguageCode(languageCode));
            history.push('/');
        }
    }, [loginStep]);

    return { loginStep, isPosting, error };
};
